// Modül 5 - Gerçek Mülakat Soruları - Ek İçerikler

const cabinCrewContentsM5Extra = {
  // Ünite 3 - Motivasyon Soruları
  'CM-M5-U3-L1': {
    title: 'Neden Kabin Memuru?',
    type: 'lesson',
    content: {
      introduction: 'En sık sorulan ve en kritik sorulardan biri. Cevabınız motivasyonunuzu göstermeli.',
      sections: [
        {
          title: 'Kaçınılması Gereken Cevaplar',
          content: '\'Seyahat etmeyi seviyorum\', \'Yüksek maaş\', \'Glamorous meslek\' gibi yüzeysel cevaplar. Bunlar herkesin söylediği şeyler.'
        },
        {
          title: 'Güçlü Cevap Unsurları',
          content: 'Hizmet tutkusu, insanlarla iletişim, dinamik çalışma ortamı, problem çözme, kültürel zenginlik.'
        },
        {
          title: 'Örnek Cevap Yapısı',
          content: 'Kişisel deneyim + Mesleğin özelliklerini bağlama + Gelecek vizyonu. Örn: Bir uçuşta yaşadığım deneyim beni derinden etkiledi...'
        }
      ],
      tips: ['Kişisel hikaye anlatın', 'Somut örnek verin', 'Güvenlik sorumluluğundan bahsedin']
    }
  },
  'CM-M5-U3-L2': {
    title: 'Neden Bu Havayolu?',
    type: 'lesson',
    content: {
      introduction: 'Her havayolu için özel cevap hazırlayın. Genel cevaplar yetmez.',
      sections: [
        {
          title: 'THY için Örnek',
          content: 'Dünyanın en çok ülkeye uçan havayolu, Türk misafirperverliği, geniş filo, Sky Trax ödülleri, köprü ülke pozisyonu.'
        },
        {
          title: 'Pegasus için Örnek',
          content: 'Genç ve dinamik yapı, hızlı büyüme, satış odaklı yaklaşım, girişimci kültür, Türkiye\'nin low-cost lideri.'
        },
        {
          title: 'Emirates/Qatar için Örnek',
          content: 'Premium servis standartları, dünya çapında tanınırlık, lüks segment, kariyer fırsatları, Dubai/Doha deneyimi.'
        }
      ],
      tips: ['Şirketi araştırın', 'Son haberleri okuyun', 'Özgün nedenler bulun']
    }
  },
  'CM-M5-U3-L3': {
    title: 'Senaryo: Motivasyon Testi',
    type: 'scenario',
    scenario: {
      title: 'İkna Edici Olmak',
      situation: 'Mülakatçı: \'Seyahat etmeyi seviyor olabilirsiniz ama kabin memurluğu sadece seyahat değil. Bunu biliyor musunuz? Gerçek motivasyonunuz ne?\'',
      question: 'Bu zorlama soruya nasıl cevap verirsiniz?',
      options: [
        { id: 'a', text: '\'Evet, seyahati seviyorum ama bunun ötesinde de var\' derim', correct: false },
        { id: 'b', text: 'Güvenlik sorumluluğu, kriz yönetimi ve insan hizmetine vurgu yaparım', correct: true },
        { id: 'c', text: '\'Maaşı da iyi\' derim', correct: false },
        { id: 'd', text: 'Seyahatin önemini savunurum', correct: false }
      ],
      explanation: 'Mülakatçı motivasyonunuzun derinliğini test ediyor. Güvenlik, hizmet ve zorluklarla başa çıkma gibi gerçek boyutları vurgulamanız beklenir.'
    }
  },
  'CM-M5-U3-L4': {
    title: '🎮 Sürukle-Bırak: Doğru Cevap',
    type: 'dragdrop',
    game: {
      instruction: '\'Neden kabin memuru?\' sorusuna doğru cevap unsurlarını sıralayın.',
      items: [
        { id: 1, text: 'Kişisel hikaye ile başla', order: 1 },
        { id: 2, text: 'Hizmet tutkusunu vurgula', order: 2 },
        { id: 3, text: 'Güvenlik sorumluluğunu ekle', order: 3 },
        { id: 4, text: 'Şirkete özel bağlantı kur', order: 4 },
        { id: 5, text: 'Gelecek vizyonuyla bitir', order: 5 }
      ],
      explanation: 'Güçlü bir motivasyon cevabı bu sırayı takip eder: Hikaye → Tutku → Sorumluluk → Şirket → Gelecek'
    }
  },

  // Ünite 4 - Senaryo Bazlı Sorular
  'CM-M5-U4-L1': {
    title: 'Zor Yolcu Türleri',
    type: 'lesson',
    content: {
      introduction: 'Farklı zor yolcu türleri ve bunlarla başa çıkma stratejileri.',
      sections: [
        {
          title: 'Sarhoş Yolcu',
          content: 'Sakin ve kararlı ol. Daha fazla alkol verme. Kokpit\'i bilgilendir. Diğer yolcuları korumak öncelik.'
        },
        {
          title: 'Agresif Yolcu',
          content: 'Göz teması kur, sakin ses tonuyla konuş. Fiziksel mesafe koru. Purser\'ı çağır. Asla karşılık verme.'
        },
        {
          title: 'Sürekli Şikayetçi Yolcu',
          content: 'Dinle, empati göster, somut çözüm öner. Mümkünse ekstra ilgi göster.'
        },
        {
          title: 'Uçuş Korkusu Olan Yolcu',
          content: 'Rahatlatcı konuş, bilgi ver (\'çok normal\'), dikkatini dağıt. Su veya çay öner.'
        }
      ],
      tips: ['Her zaman sakin kal', 'Empati göster', 'Prosedürleri bil']
    }
  },
  'CM-M5-U4-L2': {
    title: 'Tıbbi Acil Durumlar',
    type: 'lesson',
    content: {
      introduction: 'Uçuş sırasında tıbbi acil durum senaryoları ve beklenen cevaplar.',
      sections: [
        {
          title: 'Temel Yaklaşım',
          content: '1. Sakin kal, 2. Kokpit\'i bilgilendir, 3. Doktor anonsu yap, 4. First aid kit kullan, 5. Dokümantasyon.'
        },
        {
          title: 'Kalp Krizi Senaryosu',
          content: 'Yolcuyu yere yatır, AED hazırla, CPR bilgisi ol, doktor anonsu yap, acil iniş için koordine ol.'
        },
        {
          title: 'Alerjik Reaksiyon',
          content: 'EpiPen kullanımını bil, yolcuyu izole et, oksijen ver, doktor anonsu.'
        }
      ],
      tips: ['First aid eğitimini ciddiye alın', 'Prosedürleri ezberleyin', 'Sakinlik en önemli beceri']
    }
  },
  'CM-M5-U4-L3': {
    title: 'Senaryo: Türbülans Krizi',
    type: 'scenario',
    scenario: {
      title: 'Şiddetli Türbülans',
      situation: 'Servis sırasında şiddetli türbülans başladı. Yemek arabası kontrol dışı, bazı yolcular bağırıyor, bir yolcu kemerini bağlayamamış ve panik içinde.',
      question: 'Öncelik sıralamanız ne olmalı?',
      options: [
        { id: 'a', text: 'Önce arabayı sabitler, sonra yolculara yardım ederim', correct: false },
        { id: 'b', text: 'Önce kemersiz yolcuya yardım eder, sonra arabayı sabitler, sonra genel sakinleştirme yaparım', correct: true },
        { id: 'c', text: 'Önce genel sakinleştirme anonsu yaparım', correct: false },
        { id: 'd', text: 'En yakın koltuğa oturup kendi kemerimi bağlarım', correct: false }
      ],
      explanation: 'İnsan güvenliği her zaman önce gelir. Kemersiz yolcu en acil risk. Araba hasar verebilir ama öncelik değil. Kendi güvenliğiniz de önemli ama göreviniz yolcular.'
    }
  },
  'CM-M5-U4-L4': {
    title: '🎮 Acil Durum Eşleştirme',
    type: 'matching',
    game: {
      instruction: 'Acil durumu doğru aksiyonla eşleştirin.',
      pairs: [
        { left: 'Sarhoş yolcu', right: 'Alkol servisini durdur' },
        { left: 'Kalp krizi', right: 'AED hazırla + Doktor anonsu' },
        { left: 'Uçuş korkusu', right: 'Rahatlatcı konuş + Su teklif et' },
        { left: 'Agresif yolcu', right: 'Sakin kal + Purser\'a bildir' },
        { left: 'Alerjik reaksiyon', right: 'EpiPen + Oksijen' }
      ],
      timeLimit: 60
    }
  },

  // Ünite 5 - Kişisel Sorular
  'CM-M5-U5-L1': {
    title: 'Güçlü ve Zayıf Yönler',
    type: 'lesson',
    content: {
      introduction: 'Klasik ama kritik sorular. Hazırlıksız yakalanmayın.',
      sections: [
        {
          title: 'Güçlü Yönler için İpucu',
          content: 'İşe bağlı özellikler seçin: iletişim, empati, stres yönetimi, esneklik. Örnek ile destekleyin.'
        },
        {
          title: 'Zayıf Yön için Yaklaşım',
          content: 'Gerçek bir zayıflık seçin ama kritik olmayan. Üzerinde çalıştığınızı ve gelişimi gösterin.'
        },
        {
          title: 'Kaçınılacak Kliseler',
          content: '\'Mükemmeliyetci\', \'Fazla çalışkanım\' gibi sahte zayıflıklar. Mülakatçılar bunu binlerce kez duydu.'
        }
      ],
      tips: ['Somut örnekler hazırlayın', 'Gelişim gösterin', 'Dürüst ama stratejik olun']
    }
  },
  'CM-M5-U5-L2': {
    title: '5 Yıl Sonra Nerede?',
    type: 'lesson',
    content: {
      introduction: 'Kariyer hedefleriniz hakkında soru.',
      sections: [
        {
          title: 'Beklenen Cevap',
          content: 'Şirkette uzun vadeli kalma niyeti, kariyer gelişimi, purser veya eğitmen olma hedefi.'
        },
        {
          title: 'Kaçınılacak Cevaplar',
          content: '\'Kendi işimi kuracağım\', \'Pilot olacağım\' (alakasız hedefler), \'Bilmiyorum\'.'
        },
        {
          title: 'Örnek Cevap',
          content: '\'Deneyim kazandıktan sonra senior kabin memuru, uzun vadede purser veya eğitim departmanında görev almak istiyorum.\''
        }
      ],
      tips: ['Şirkete sadık görün', 'Gerçekçi hedefler belirleyin', 'Gelişim odaklı olun']
    }
  },
  'CM-M5-U5-L3': {
    title: 'Senaryo: Provokasyon Sorusu',
    type: 'scenario',
    scenario: {
      title: 'Zayıf Nokta Testi',
      situation: 'Mülakatçı ısrarla soruyor: \'CV\'nizde 6 aylık boşluk var. Bu süre ne yaptınız? Neden iş bulamadınız?\'',
      question: 'Bu zorlama soruya nasıl yaklaşırsınız?',
      options: [
        { id: 'a', text: 'Savunmaya geçer ve ekonomiyi suçlarım', correct: false },
        { id: 'b', text: 'Bu sürede ne öğrendiğimi ve kendimi nasıl geliştirdiğimi anlatırım', correct: true },
        { id: 'c', text: '\'Bu özel bir konu\' deyip geçiştiririm', correct: false },
        { id: 'd', text: 'Yalan söyleyip boşluk olmadığını iddia ederim', correct: false }
      ],
      explanation: 'CV boşlukları normal. Önemli olan bu süreyi nasıl değerlendirdiğiniz: kurs, gönüllü çalışma, dil öğrenimi, aile sorumlulukları vb.'
    }
  },
  'CM-M5-U5-L4': {
    title: '⚡ Kişisel Soru Yarışı',
    type: 'timerace',
    game: {
      instruction: '50 saniyede kişisel sorular hakkındaki doğru yaklaşımları seçin!',
      questions: [
        { question: 'Zayıf yön sorusunda kaçınılacak?', answer: 'Mükemmeliyetcilik', options: ['Gerçek zayıflık', 'Mükemmeliyetcilik', 'Gelişim', 'Örnek'] },
        { question: '5 yıl sorusunda vurgulanacak?', answer: 'Şirkete bağlılık', options: ['Kendi iş', 'Şirkete bağlılık', 'Bilmiyorum', 'Pilot olmak'] },
        { question: 'CV boşluğu için ne söylenmeli?', answer: 'Gelişim fırsatları', options: ['Yalan', 'Gelişim fırsatları', 'Ekonomi', 'Hiçbir şey'] },
        { question: 'Güçlü yön örneği nasıl verilmeli?', answer: 'Somut olay ile', options: ['Genel', 'Somut olay ile', 'Kısa', 'Örnek vermeden'] }
      ],
      timeLimit: 50
    }
  },

  // Ünite 6 - Ekip Çalışması Soruları
  'CM-M5-U6-L1': {
    title: 'Ekip İçi Çatışma',
    type: 'lesson',
    content: {
      introduction: 'Ekip arkadaşıyla yaşanan anlaşmazlık senaryoları.',
      sections: [
        {
          title: 'Tipik Soru',
          content: '\'Bir iş arkadaşınızla anlaşmazlık yaşadığınız bir durumu anlatır mısınız?\''
        },
        {
          title: 'STAR Metodu',
          content: 'Situation (Durum) - Task (Görev) - Action (Aksiyon) - Result (Sonuç). Her cevap bu yapıda olmalı.'
        },
        {
          title: 'Önemli Noktalar',
          content: 'Suçlamayın, çözüm odaklı olun, iletişimi vurgulayayın, sonucu pozitif kapatın.'
        }
      ],
      tips: ['Gerçek bir örnek hazırlayın', 'STAR formatını kullanın', 'Pozitif sonuç vurgulayayın']
    }
  },
  'CM-M5-U6-L2': {
    title: 'Senaryo: Zor Meslektaş',
    type: 'scenario',
    scenario: {
      title: 'Ekip Anlaşmazlığı',
      situation: 'Uçuşta senior kabin memuru size karşı kırıcı ve adaletsiz davranıyor. Diğer ekip üyeleri de bunu fark ediyor ama kimse müdahale etmiyor.',
      question: 'Bu durumu nasıl yönetirsiniz?',
      options: [
        { id: 'a', text: 'Uçuş boyunca sessiz kalır, sonra şikayet ederim', correct: false },
        { id: 'b', text: 'Uçuş sonrası özel olarak konuşur, sorunu anlamaya çalışırım', correct: true },
        { id: 'c', text: 'Aynı şekilde karşılık veririm', correct: false },
        { id: 'd', text: 'Diğer ekip üyelerine şikayıet ederim', correct: false }
      ],
      explanation: 'Direkt iletişim, profesyonelce ve özel olarak konuşmak en doğru yaklaşımdır. Dedikodu veya pasif agresiflik kaçınılmalıdır.'
    }
  },
  'CM-M5-U6-L3': {
    title: '🎮 STAR Eşleştirme',
    type: 'matching',
    game: {
      instruction: 'STAR metodunun unsurlarını doğru açıklamayla eşleştirin.',
      pairs: [
        { left: 'Situation', right: 'Durumu/ortamı tanımlama' },
        { left: 'Task', right: 'Sizin göreviniz/sorumluluğunuz' },
        { left: 'Action', right: 'Aldığınız aksiyonlar' },
        { left: 'Result', right: 'Sonuç ve öğrenilenler' }
      ],
      timeLimit: 40
    }
  },

  // Ünite 7 - Final Quiz
  'CM-M5-U7-L1': {
    title: '🎓 Modül 5 Final Sınavı',
    type: 'exam',
    exam: {
      title: 'Gerçek Mülakat Soruları - Final Sınavı',
      passingScore: 70,
      questions: [
        {
          question: '\'Neden kabin memuru?\' sorusunda kaçınılacak cevap?',
          options: ['Hizmet tutkusu', 'Seyahat etmeyi seviyorum', 'Güvenlik sorumluluğu', 'Dinamik ortam'],
          correct: 1
        },
        {
          question: 'Sarhoş yolcu karşısında ilk aksiyon?',
          options: ['Daha alkol vermek', 'Alkol servisini durdurmak', 'Yolcuyu uyarmak', 'Polis çağırmak'],
          correct: 1
        },
        {
          question: 'STAR metodunda \'A\' ne anlama gelir?',
          options: ['Attitude', 'Action', 'Approach', 'Analysis'],
          correct: 1
        },
        {
          question: 'Zayıf yön sorusunda ideal yaklaşım?',
          options: ['Zayıflık yok demek', 'Gerçek zayıflık + gelişim', 'Mükemmeliyetcilik demek', 'Cevap vermemek'],
          correct: 1
        },
        {
          question: 'Uçuş korkusu olan yolcuya ne yapılır?',
          options: ['Görmezden gel', 'Rahatlatcı konuş ve su teklif et', 'Uçaktan in', 'Alay et'],
          correct: 1
        },
        {
          question: '5 yıl sonra sorusunda vurgulanacak?',
          options: ['Kendi iş kurma', 'Şirkette kariyer gelişimi', 'Pilot olma', 'Emeklilik'],
          correct: 1
        },
        {
          question: 'Ekip anlaşmazlığında en doğru yaklaşım?',
          options: ['Dedikodu', 'Özel ve direkt iletişim', 'Sessiz kalma', 'Karşılık verme'],
          correct: 1
        },
        {
          question: 'Türbülans anında öncelik?',
          options: ['Yemek arabası', 'İnsan güvenliği', 'Servis tamamlama', 'Telefon'],
          correct: 1
        }
      ]
    }
  }
};

export default cabinCrewContentsM5Extra;
